import { ReactNode } from 'react';
import { Stack, Typography } from '@optimus-web/core';
import { LocalizedEnum, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AvailabilityBlockState } from '@mews-commander/data-access';
import { SpacedForwardSlash } from '@mews-commander/ui';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { BlockSetUpAsideTotalWrapper } from '../styles';
import { useAvailabilityBlock } from '../../../../../utils/useAvailabilityBlock';

interface AsideTotalCellProps extends WithAvailabilityBlockId {
    isEditingAvailability: boolean;
}

const AsideTotalCell = ({ isEditingAvailability, availabilityBlockId }: AsideTotalCellProps) => {
    const availabilityBlock = useAvailabilityBlock(availabilityBlockId);
    if (!availabilityBlock) return null;

    const { state } = availabilityBlock;

    return state === AvailabilityBlockState.Confirmed ? (
        <AsideTotalCellBody
            showSlash
            beforeSlash={lt(!isEditingAvailability ? TextKey.PickedUp : TextKey.Blocked)}
            afterSlash={lt(!isEditingAvailability ? TextKey.Blocked : TextKey.Available)}
        />
    ) : (
        <AsideTotalCellBody
            showSlash={isEditingAvailability}
            beforeSlash={<LocalizedEnum prefix="AvailabilityBlockState" value={state} />}
            afterSlash={lt(TextKey.Available)}
        />
    );
};

const AsideTotalCellBody: React.FC<{
    showSlash: boolean;
    beforeSlash: ReactNode;
    afterSlash: ReactNode;
}> = ({ showSlash, beforeSlash, afterSlash }) => (
    <BlockSetUpAsideTotalWrapper>
        <Stack itemAlignment="center" fill alignment="end" spacing="100">
            <Stack>
                <Typography textStyle="bodySmallStrong" as="div">
                    {beforeSlash}
                </Typography>

                {showSlash && (
                    <Typography textStyle="bodySmall" variant="secondary" as="div">
                        {SpacedForwardSlash}
                        {afterSlash}
                    </Typography>
                )}
            </Stack>
        </Stack>
    </BlockSetUpAsideTotalWrapper>
);

export default AsideTotalCell;
